import React from 'react';
import { DownloadPrompt } from '@src/components/DownloadPrompt';
import { setPopup } from '@src/state/popupAtoms';
import { EPopup } from '@src/types/common';

interface Props {
  collectionId: string
}

function DownloadCollection({ collectionId }: Props) {
  return (
    <DownloadPrompt
      collectionId={collectionId}
      hide={() => setPopup(EPopup.downloadCollection, null)}
    />
  );
}

export { DownloadCollection };
